import { Component, Input } from "@angular/core";

import { IDriver } from "../../../driver/driver.interface";

@Component({
  selector: 'app-driver-post-incident',
  templateUrl: './incident.component.html',
})
export class DriverPostIncidentComponent {
  @Input() driver: IDriver;
}
